export default __webpack_public_path__ + "static/media/sana3.8a09220f.mp4";